    
<app-admin-side-bar></app-admin-side-bar>

<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-dark">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" appRemoveOverlayDirective data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a class="nav-link">Home</a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a class="nav-link"></a>
    </li>
  </ul>

  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">
    <!-- <li class="nav-item dropdown">
      <a><app-admin-test-mode></app-admin-test-mode> </a>
    </li> -->
  </ul>
</nav>
<!-- /.navbar -->


<div class="content-wrapper" style="height: auto;">
    <!-- <app-loader *ngIf="Loader==true"></app-loader> -->
    <app-loader  *ngIf="Loader"></app-loader>

    
    <div class="container-fluid" style="padding:1px;">

        <div class="mb-3" style="background-color: #343a40; height: 125px;">
            <!-- <div class="col-mb-12"> -->



                <!-- <div class="search-banner has-bg mt-1"> -->

                   
                    <div class="row" style="text-align: center;">
                        <h1 style="color: white;">ENTER CUSTOMER NUMBER</h1>
                        <div class="offset-md-3 col-md-5">
                            <div class="input-group">
                                <input [value]="PridCustomerMobileNumber1" type="text"
                                    class="form-control form-control-lg" placeholder="XXX-XXX-XXXX" name="number"
                                    id="mnumber" #mob_number required="" style="font-size: 40px;" maxlength="15">
                                <span class="input-group-append">
                                    <button type="button" class="btn btn-lg  btn-default" id="number" style="padding:25px"
                                        (click)="CreateRetailer(mob_number.value)"><i
                                            class="fa fa-angle-right fa-lg"></i></button>
                                </span>
                                <span class="input-group-append">
                                    <button type="button" class="btn btn-lg  btn-default" id="number" style="padding:25px"
                                        (click)="clearCookie()"><i class="fa fa-rotate-right fa-lg"></i></button>
                                </span>
                            </div>
                        </div>
                    </div>

                <!-- </div> -->
            <!-- </div> -->
        </div>

        <!-- <div class="mt-5"> -->
            <div class="row">
            <div class="col-lg-9">
                <div class="col">
                    <a class="btn btn-primary w-100 collapsable" data-toggle="collapse" href="#multiCollapseExample1"
                        role="button" aria-expanded="true" aria-controls="multiCollapseExample1">
                        <i class="fa fa-globe"></i>
                        &nbsp; INTERNATIONAL TOP UP
                        &nbsp;&nbsp;&nbsp;
                        <img src="https://imagerepo.ding.com/flag/LR.png" style="max-width:2%;"> &nbsp;
                        &nbsp;
                        <img src="https://imagerepo.ding.com/flag/SL.png" style="max-width:2%;"> &nbsp;
                        &nbsp;
                        <img src="https://imagerepo.ding.com/flag/GN.png" style="max-width:2%;"> &nbsp;
                        &nbsp;
                        <img src="https://www.prid.io/retailer/public/flags/flag-of-Haiti.png" style="max-width:2%;">
                        &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/flags/flag-of-Jamaica.png" style="max-width:2%;">
                        &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/flags/flag-of-Dominican-Republic.png"
                            style="max-width:2%;"> &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/flags/flag-of-Mexico.png" style="max-width:2%;">
                        &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/flags/flag-of-Liberia.png" style="max-width:2%;">
                        &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/flags/flag-of-Papua-New-Guinea.png"
                            style="max-width:2%;"> &nbsp; &nbsp;

                            <i class="fa-regular fa-window-minimize" style="color: white; float: right; font-size: 17px;"></i>

                    </a>
                    <br>
                    <div class="collapse multi-collapse" id="multiCollapseExample1">
                        <br>
                    <div class="row">
                        <div class="offset-md-10 col-lg-3">
                            <button class="btn btn-primary collapsable" data-toggle="collapse"
                                href="#multiCollapseExample3" role="button" aria-expanded="false"
                                aria-controls="multiCollapseExample3">
                                <i class="fa fa-plus"></i> Add New</button>
                        </div>
                        
                    </div>
                    <br>
                            <div class="collapse multi-collapse" id="multiCollapseExample3">
                                <div class="international-topup-controls row">
                                    <!-- International Mobile No -->
                                    <div class="col-lg-4">
                                        <label><b>International Mobile No</b></label>
                                        <div class="input-group">
                                            <img [src]="countryFlagImg" alt="Flag" style="width: 40px; margin-right: 8px;">
                                            <input 
                                                (input)="countryFlagFilter(reqPhoneNumber.value, $event)"
                                                (keypress)="($event.charCode >= 48 && $event.charCode < 58)" 
                                                (keydown.space)="$event.preventDefault()" 
                                                [(ngModel)]="filterCountry" 
                                                #reqPhoneNumber
                                                class="form-control">
                                            <button class="btn btn-secondary" (click)="GetProvidersProductsByNumber(reqPhoneNumber.value)" *ngIf="numberLoader==0">
                                                <i class="fa fa-arrow-right"></i>
                                            </button>
                                            <app-small-loader *ngIf="numberLoader==1"></app-small-loader>
                                        </div>
                                    </div>
                                
                                    <!-- Select Country -->
                                    <div class="col-lg-2">
                                        <label><b>Select Country</b></label>
                                        <input 
                                            list="suggest" 
                                            class="form-control" 
                                            #intlCountry
                                            disabled 
                                            (input)="GetProviders(intlCountry.value)" 
                                            value="{{CountryValue}}">
                                        <datalist id="suggest">
                                            <option *ngFor="let item of intlcountryList" value="{{item.value}}">
                                                {{item.label}}
                                            </option>
                                        </datalist>
                                    </div>
                                
                                    <!-- Amount -->
                                    <div class="col-lg-2">
                                        <label><b>Amount</b></label>
                                        <input 
                                            [disabled]="boolIntlAmountValue" 
                                            #internationalAmountValue 
                                            type="number"
                                            [value]="intlAmountValue" 
                                            #intlAmount 
                                            class="form-control">
                                        <p *ngIf="boolAmountRange" class="text-muted">
                                            Min price: {{intlSelectedProduct.minimum.sendValue}} - Max price: {{intlSelectedProduct.maximum.sendValue}}
                                        </p>
                                    </div>
                                
                                    <!-- First Name -->
                                    <div class="col-lg-2">
                                        <label><b>First Name</b></label>
                                        <input type="text" #firstName class="form-control">
                                    </div>
                                
                                    <!-- Last Name -->
                                    <div class="col-lg-2">
                                        <label><b>Last Name</b></label>
                                        <input type="text" #lastName class="form-control">
                                    </div>
                                </div>
                                
                                
                            
                                <div class="row mt-3">
                                    <!-- Add to Cart Button -->
                                    <div class="col-lg-12">
                                        <button 
                                            style="float: right; width: 17%; height: 45px; font-size: 17px;" 
                                            [disabled]="SubmitOrderButton" 
                                            type="button" 
                                            class="btn btn-dark"
                                            (click)="AddToCartInternational(intlAmount.value, 'UK', reqPhoneNumber.value, firstName.value, lastName.value)">
                                            Add to Cart
                                        </button>
                                    </div>
                                </div>
                                <!-- Provider -->
                                <div class="row" *ngIf="boolShowProviderInternational==true">
                                    <div class="col-lg-12">
                                        <hr>
                                        <h3>Provider</h3>
                                        <ol *ngIf="selectedItemInternational==null" class="domesticCards">
                                            <li *ngFor="let item of intlprovidersOption"
                                                (click)="onItemClickInternational(item,reqPhoneNumber.value)"
                                                [class.selected]="selectedItemInternational === item">
                                                <div class="icon">
                                                    <img style="width: 60px;" [src]="item.label2" />
                                                </div>
                                                <div class="descr">{{ item.label }}
                                                    
                                                </div>
                                            </li>
                                        </ol>

                                        <div *ngIf="selectedItemInternational">
                                            <ol class="domesticCards">
                                                <li>
                                                    <div class="icon"><img style="width: 60px;"
                                                            src="{{selectedItemInternational.label2}}"></div>
                                                    <div class="descr">{{selectedItemInternational.label}}
                                                        <!-- will be received<br>
                                                        *including bonus if applicable<br>
                                                        *T&C's apply to bonus credit -->
                                                    </div>

                                                </li>
                                            </ol>
                                            <a style="color:rgb(87, 87, 241); cursor: pointer;"
                                                (click)="changeProviderInternational(reqPhoneNumber.value)">Select Provider</a>
                                            <!-- <div>
                                              <div class="icon">
                                                <img style="width: 60px;" [src]="selectedItem.label2" />
                                              </div>
                                              <div class="descr">{{ selectedItem.label }}</div>
                                            </div> -->
                                        </div>

                                        <!-- <ol class="domesticCards">
                                            <li *ngFor="let item of dmstcProviderOptions">
                                                <div class="icon"><img style="width: 60px;" src="{{item.label2}}"></div>
                                                <div class="descr">{{item.label}}</div>

                                            </li>
                                        </ol> -->

                                    </div>
                                </div>
                                <!-- Products -->
                                <div class="row" *ngIf="boolShowAmountInternational==true">
                                        
                                        <div class="col-lg-12">
                                            <hr>
                                            <h3>Product</h3>
                                            <ol class="domesticProductCards">
                                                <li *ngFor="let item of intlproductsOption"
                                                    (click)="onItemProductClickInternational(item)"
                                                    [class.selected]="selectedItemProductInternational === item">
                                                    <div class="title">{{ item.label }}</div>
                                                    <div class="descr">{{ item.label }}
                                                        <p>{{item.defaultDisplayText }}</p>
                                                    </div>
                                                </li>
                                            </ol>
    
                                            <div *ngIf="selectedItemProduct">
                                                <ol class="domesticProductCards">
                                                    <li>
                                                        <div class="title">{{ selectedItemProduct.label }}</div>
                                                        <div class="descr">{{ selectedItemProduct.label }}
                                                            will be received<br>
                                                            *including bonus if applicable<br>
                                                            *T&C's apply to bonus credit
                                                        </div>
                                                    </li>
                                                </ol>
                                                <a style="color:rgb(87, 87, 241); cursor: pointer;"
                                                    (click)="backSelectProduct()">backSelectProduct</a>
                                            </div>
    
                                        </div>
                                        
                                </div>
                                
                            </div>
                            <br>
                            <div class="row">
                                <div class="offset-md-10 col-lg-3">
                                    <button class="btn btn-primary collapsable" data-toggle="collapse"
                                        href="#multiCollapseExample7" role="button" aria-expanded="false"
                                        aria-controls="multiCollapseExample7">
                                        <i class="fa fa-history"></i> History</button>
                                </div>
                                
                            </div>
                            <br>
                    <div class="collapse multi-collapse" id="multiCollapseExample7">
                        <div class="card card-body">
                            <div *ngFor="let topUp of TopupList">
                                <span class="widget-list-item row" *ngIf="topUp.productType==2">

                                    <div *ngIf="topUp.productType==2" class="widget-list-media text-center col-2">
                                        <span style="font-size:9px;">{{topUp.pridReferenceNumber}} </span><br>
                                        <img [src]="topUp.logoUrl" style="width: 45%;" class="rounded">
                                    </div>
                                    <div *ngIf="topUp.productType==2" class="col-7">
                                        <h4 class="widget-list-title" style="font-size: 18px !important;">{{topUp.accountNumber}}</h4> <h4>{{topUp.firstName}} {{topUp.lastName}}</h4>
                                        <p style="font-size: 18px;" class="widget-list-desc"> {{topUp.providerName}} - <span
                                                class="label label-info"><b>Topup</b></span>
                                            &nbsp; <span class="label label-primary"> Recharge Date :{{topUp.creationTime |
                                                 date:'MM/dd/yyyy' }}</span>
                                           
                                        </p>
                                    </div>
    
                                    <!-- <div class="col-1">
                                            <div class="input-group" style="height: 60px;">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="fa fa-dollar"></i></span>
        
                                                </div>
                                                <input type="text" class="form-control" sty name="hiddenamount" value="10"
                                                    style="width:45px; height: 60px;" required="">
                                                <input type="hidden" class="form-control" name="amount" value="10"
                                                    style="width:45px;" required="">
        
                                            </div>
                                        </div> -->
    
                                    <div *ngIf="topUp.productType==2" class="col-3 mt-3">
                                        <div class="input-group ">
                                            <div class="input-group-prepend">
                                               
                                                <span class="input-group-button"> 
                                                    <button 
                                                        class="btn btn-xs btn-primary addtocart  pull-right" style="border: 0px;
                                                        font-size: 18px;
                                                        background: #dde0e5;
                                                        color: black;"
                                                        data-id="top-add-cart-14840" (click)="reloadProduct(topUp,reqPhoneNumber)" data-form="topup" type="submit"><i
                                                            style="font-size: 18px; padding: 10px;"
                                                            class="fa fa-dollar"> {{topUp.sendValue}}</i> </button>
                                                </span>
                                                &nbsp;
                                                <span class="input-group-button"> 
                                                    <button [disabled]="SubmitOrderButton==true" (click)="OrderByRefNum(topUp.pridReferenceNumber,topUp.sendValue)"
                                                        class="btn btn-xs btn-success addtocart  pull-right"
                                                        data-id="top-add-cart-14840" data-form="topup" type="submit"><i
                                                            style="font-size: 18px; padding: 10px;"
                                                            class="fa fa-cart-plus"></i></button>
                                                </span>
    
                                            </div>
                                            &nbsp;
                                            <a href="javascript:;" data-remove="top-add-cart-14840"
                                                data-url="https://www.prid.io/retailer/remove-number/14840"
                                                style="background-color:#efaa45" (click)="DeleteOrderHistory(topUp.pridReferenceNumber)"
                                                class="btn btn-xs btn-warning btn-remove-number ml-1"><i
                                                    style="font-size: 18px; padding: 10px; color: white;"
                                                    class="fa fa-trash"></i></a>
    
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <br>
                            
                        </div>
                    </div>
                </div>
                </div>
                <br>

                <div class="col">
                    <a class="btn btn-primary w-100 collapsable" type="button" data-toggle="collapse"
                        data-target="#multiCollapseExample2" aria-expanded="false"
                        aria-controls="multiCollapseExample2"><i class="fa fa-location-arrow"></i>
                        &nbsp; DOMESTIC TOPUP
                        &nbsp;&nbsp;&nbsp;
                        <img src="https://www.prid.io/retailer/public/carriers/at&t.png" style="max-width:2%;"> &nbsp;
                        &nbsp;
                        <img src="https://www.prid.io/retailer/public/carriers/boost-mobile.png" style="max-width:2%;">
                        &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/carriers/simple-mobile.png" style="max-width:2%;">
                        &nbsp; &nbsp;
                        <img src="https://www.prid.io/retailer/public/carriers/t-mobile.png" style="max-width:2%;">
                        &nbsp; &nbsp;

                        <i class="fa-regular fa-window-minimize" style="color: white; float: right; font-size: 17px;"></i>

                    </a>

                    <div class="collapse multi-collapse" id="multiCollapseExample2">
                        <div class="card card-body">
                            <!-- <button class="btn btn-primary collapsable" style="width: 10%;" data-toggle="collapse"
                                href="#multiCollapseExample4" role="button" aria-expanded="false"
                                aria-controls="multiCollapseExample4" (click)="GetDomesticProviders()"> -->
                            <!-- <i class="fa fa-plus"></i> Add New</button><br> -->
                            <div>
                                
                               
                                    <div class="col-lg-12 domestic-topup">
                                        <div class="row align-items-center">
                                            <div class="col-lg-2">
                                                <b>Domestic Mobile No</b>
                                            </div>
                                            <div class="col-lg-2">
                                                <div class="form-group">
                                                    <select class="form-control form-control-lg" id="countryCode"
                                                        name="countryCode" [(ngModel)]="selectedCountryCode">
                                                        <option value="+1" selected>+1 (USA)</option>
                                                        <!-- Add more options as needed -->
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-lg-7">
                                                <input (keypress)="($event.charCode >= 48 && $event.charCode < 58)" type="text" class="form-control form-control-lg"
                                                    name="phoneNumber" #accountNo value="{{DomesticMobileNumber}}">
                                            </div>
                                            <div class="col-lg-1">
                                                <i *ngIf="MiniLoader==false" (click)="domesticNumberProcess(accountNo.value)"
                                                    class="fa fa-arrow-right" style="font-size: 41px;"></i>
                                                <app-small-loader *ngIf="MiniLoader==true"></app-small-loader>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <p style="color: red;">{{domesticPhoneError}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                           
                                <div class="row" *ngIf="boolShowAmount==true">
                                    
                                    <div class="col-lg-12">
                                        <b>Amount</b>
                                        <input [value]="dmstcAmountValue" [disabled]="boolDmstcAmountValue"
                                            type="number" class="form-control form-control-lg mt-2" #dmstcAmount>
                                        <p *ngIf="boolAmountRange==true">Min price:
                                            {{intlSelectedProduct.minimum.sendValue}} - Max price:
                                            {{intlSelectedProduct.maximum.sendValue}}</p>
                                    </div>
                                    

                                    <!-- <div class="col-lg-2"></div>
                                    <div class="col-lg-4">
                                        <b>First Name</b>
                                        <input type="text" #DomesticFirstName class="form-control form-control-lg mt-2">
                                    </div>
                                    <div class="col-lg-4">
                                        <b>Last Name</b>
                                        <input type="text" #DomesticLastName class="form-control form-control-lg mt-2">
                                    </div>
                                    <div class="col-lg-2"></div> -->

                                    <div class="col-lg-12 mt-3">
                                        <button style="float: right; width: 17%;height: 45px;font-size: 17px;" [disabled]="SubmitOrderButton==true" type="button" class="btn btn-dark"
                                            (click)="AddToCartDomestic(dmstcAmount.value,'1',accountNo.value)">Add
                                            to
                                            Cart</button>
                                    </div>
                                </div>
                                <!-- Provider -->
                                <div class="row" *ngIf="boolShowProvider==true">
                                    
                                    <div class="col-lg-12">
                                        <hr>
                                        <h3>Provider</h3>
                                        <ol *ngIf="selectedItem==null" class="domesticCards">
                                            <li *ngFor="let item of dmstcProviderOptions"
                                                (click)="onItemClick(item,accountNo.value)"
                                                [class.selected]="selectedItem === item">
                                                <div class="icon">
                                                    <img style="width: 60px;" [src]="item.label2" />
                                                </div>
                                                <div class="descr">{{ item.label }}</div>
                                            </li>
                                        </ol>

                                        <div *ngIf="selectedItem">
                                            <ol class="domesticCards">
                                                <li>
                                                    <div class="icon"><img style="width: 60px;"
                                                            src="{{selectedItem.label2}}"></div>
                                                    <div class="descr">{{selectedItem.label}}</div>

                                                </li>
                                            </ol>
                                            <a style="color:rgb(87, 87, 241); cursor: pointer;"
                                                (click)="changeProvider()">Select Provider</a>
                                            <!-- <div>
                                              <div class="icon">
                                                <img style="width: 60px;" [src]="selectedItem.label2" />
                                              </div>
                                              <div class="descr">{{ selectedItem.label }}</div>
                                            </div> -->
                                        </div>

                                        <!-- <ol class="domesticCards">
                                            <li *ngFor="let item of dmstcProviderOptions">
                                                <div class="icon"><img style="width: 60px;" src="{{item.label2}}"></div>
                                                <div class="descr">{{item.label}}</div>

                                            </li>
                                        </ol> -->

                                    </div>
                                    
                                </div>
                                <!-- Product -->
                                <div class="row" *ngIf="boolShowAmount==true">
                                    
                                    <div class="col-lg-12">
                                        <hr>
                                        <h3>Product</h3>
                                        <ol *ngIf="selectedItemProduct==null" class="domesticProductCards">
                                            <li *ngFor="let item of dmstcProductOptions"
                                                (click)="onItemProductClick(item)"
                                                [class.selected]="selectedItemProduct === item">
                                                <div class="title">{{ item.label }}</div>
                                                <div class="descr">{{ item.label }}
                                                   <p>{{item.defaultDisplayText}}</p>
                                                </div>
                                            </li>
                                        </ol>

                                        <div *ngIf="selectedItemProduct">
                                            <ol class="domesticProductCards">
                                                <li>
                                                    <div class="title">{{ selectedItemProduct.label }}</div>
                                                    <div class="descr">{{ selectedItemProduct.label }}
                                                        will be received<br>
                                                        *including bonus if applicable<br>
                                                        *T&C's apply to bonus credit
                                                    </div>
                                                </li>
                                            </ol>
                                            <a style="color:rgb(87, 87, 241); cursor: pointer;"
                                                (click)="backSelectProduct()">backSelectProduct</a>
                                        </div>

                                    </div>
                                    
                                </div>
                                <br>
                                
                                <div *ngFor="let topUp of TopupList">
                                    <span class="widget-list-item row align-items-center g-3" *ngIf="topUp.productType==1">
                                        <div *ngIf="topUp.productType==1" class="widget-list-media text-center col-2">
                                            <span style="font-size:9px;">{{topUp.pridReferenceNumber}}</span><br>
                                            <img [src]="topUp.logoUrl" style="width: 45%;" class="rounded">
                                        </div>
                                        <div *ngIf="topUp.productType==1" class="col-7">
                                            <h4 class="widget-list-title" style="font-size: 18px !important;">{{topUp.accountNumber}}</h4>
                                            <h4>{{topUp.firstName}} {{topUp.lastName}}</h4>
                                            <p style="font-size: 18px;" class="widget-list-desc">{{topUp.providerName}} - 
                                                <span class="label label-info"><b>Topup</b></span>
                                                <span class="label label-primary"> Recharge Date: {{topUp.creationTime | date:'MM/dd/yyyy'}}</span>
                                            </p>
                                        </div>
                                        <div *ngIf="topUp.productType==1" class="col-3 mt-3">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-button">
                                                        <button class="btn btn-xs btn-primary addtocart pull-right" style="border: 0px; font-size: 18px; background: #dde0e5; color: black;" data-id="top-add-cart-14840" data-form="topup" type="submit">
                                                            <i class="fa fa-dollar" style="font-size: 18px; padding: 10px;"></i> {{topUp.sendValue}}
                                                        </button>
                                                    </span>
                                                    <span class="input-group-button">
                                                        <button [disabled]="SubmitOrderButton==true" (click)="OrderByRefNum(topUp.pridReferenceNumber, topUp.sendValue)" class="btn btn-xs btn-success addtocart pull-right" data-id="top-add-cart-14840" data-form="topup" type="submit">
                                                            <i class="fa fa-cart-plus" style="font-size: 18px; padding: 10px;"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                                <a href="javascript:;" class="btn btn-xs btn-warning btn-remove-number ml-1" data-remove="top-add-cart-14840" data-url="https://www.prid.io/retailer/remove-number/14840" (click)="DeleteOrderHistory(topUp.pridReferenceNumber)" style="background-color:#efaa45; color: white;">
                                                    <i class="fa fa-trash" style="font-size: 18px; padding: 10px;"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="col">
                    <a (click)="loadRecievers(); loadActiveCountries()" class="btn btn-primary w-100 collapsable" type="button"
                        data-toggle="collapse" data-target="#multiCollapseExample6" aria-expanded="false"
                        aria-controls="multiCollapseExample3">
                        <i class="fa fa-shopping-cart"></i> &nbsp;
                        PRID PRODUCTS
                        <img src="https://imagerepo.ding.com/flag/LR.png" style="max-width:2%;"> &nbsp;
                        &nbsp;
                        <img src="https://imagerepo.ding.com/flag/SL.png" style="max-width:2%;"> &nbsp;
                        &nbsp;
                        <img src="https://imagerepo.ding.com/flag/GN.png" style="max-width:2%;"> &nbsp;
                        &nbsp;

                        <i class="fa-regular fa-window-minimize" style="color: white; float: right; font-size: 17px;"></i>

                    </a>
                    <div class="collapse multi-collapse" id="multiCollapseExample6">
                        <div class="card card-body" style="min-height: 800px;">
                            <div class="row d-flex align-items-center pridproducts-controls">
                                <h3 class="col-12 mb-3"><b>Customer Details</b></h3>
                            
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>First Name *</b>
                                        <input [disabled]="boolPridCustomerLastName" 
                                               type="text"
                                               class="form-control form-control-lg" 
                                               #CustomerFirstName
                                               value="{{PridCustomerFirstName}}">
                                    </div>
                                </div>
                            
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>Last Name *</b>
                                        <input type="text" 
                                               class="form-control form-control-lg" 
                                               #CustomerLastName
                                               [disabled]="boolPridCustomerLastName" 
                                               value="{{PridCustomerLastName}}">
                                    </div>
                                </div>
                            
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <b>Email</b>
                                        <input type="text" 
                                               class="form-control form-control-lg" 
                                               #CustomerEmail
                                               [disabled]="boolPridCustomerLastName" 
                                               value="{{PridCustomerEmail}}">
                                    </div>
                                </div>
                            
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>Mobile *</b>
                                        <input type="text" 
                                               class="form-control form-control-lg" 
                                               #CustomerPhone 
                                               disabled
                                               value="{{PridCustomerMobileNumber1}}">
                                    </div>
                                </div>
                            
                                <div class="col-lg-2">
                                    <div class="form-group w-100" style="margin-bottom: -5px;">
                                        <button [disabled]="boolPridCustomerLastName" 
                                                (click)="UpdateCustomer(CustomerFirstName.value, 
                                                                        CustomerLastName.value, 
                                                                        CustomerEmail.value, 
                                                                        CustomerPhone.value)" 
                                                class="btn btn-success btn-lg w-100">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <br>

                            <div class="row d-flex align-items-center pridproducts-controls">
                                <h3 class="col-12 mb-3"><b>Receiver Details</b></h3>
                            
                                <!-- Select Receiver -->
                                <div class="col-lg-2">
                                    <b>Select Receiver</b>
                                    <select [disabled]="boolProductSection" class="form-control form-control-lg" style="margin-bottom: 10px;" (change)="recieverSelect($event.target)">
                                        <option selected disabled>Select Receiver</option>
                                        <option *ngFor="let item of recieversOptions" value="{{item.value}}">
                                            {{item.label}}
                                        </option>
                                    </select>
                                </div>
                            
                                <!-- First Name -->
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>First Name *</b>
                                        <input type="text" class="form-control form-control-lg" #recieverFirstName
                                               [disabled]="!boolRecieverFirstName" value="{{recieverfirstName}}">
                                    </div>
                                </div>
                            
                                <!-- Last Name -->
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>Last Name *</b>
                                        <input type="text" class="form-control form-control-lg" #recieverLastName
                                               [disabled]="!boolRecieverFirstName" value="{{recieverlastName}}">
                                    </div>
                                </div>
                            
                                <!-- Mobile -->
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>Mobile *</b>
                                        <input type="text" class="form-control form-control-lg" #pridrecieverMobile
                                               [disabled]="!boolRecieverMobile" value="{{recieverMobile}}">
                                    </div>
                                </div>
                            
                                <!-- Mobile Number 2 -->
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <b>Mobile Number 2</b>
                                        <input type="text" class="form-control form-control-lg" #pridrecieverEmail
                                               [disabled]="!boolRecieverFirstName" value="{{recieverEmail}}">
                                    </div>
                                </div>
                            
                                <!-- Add Receiver Button -->
                                <div class="col-lg-2 d-flex align-items-center">
                                    <div class="form-group w-100" style="margin-bottom:-5px">
                                        <button [disabled]="!addReceiverButton" (click)="AddReceiver(recieverFirstName.value,
                                                                                                     recieverLastName.value,
                                                                                                     pridrecieverEmail.value,
                                                                                                     pridrecieverMobile.value)" 
                                                class="btn btn-success btn-lg w-100">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Select Country, City, and Product -->
                            <div class="row mt-5 pridproducts-controls">
                                <!-- Select Country -->
                                <div class="col-lg-2">
                                    <b>Select Country</b>
                                    <select [disabled]="boolProductSection==true" class="form-control form-control-lg mt-2" (change)="changeActiveCountry($event.target)">
                                        <option *ngFor="let country of pridActiveCountries" value="{{country.value}}">
                                            {{country.label}}
                                        </option>
                                    </select>
                                </div>
                            
                                <!-- Select City -->
                                <div class="col-lg-2">
                                    <b>Select City</b>
                                    <select [disabled]="boolProductSection==true" class="form-control form-control-lg mt-2" (change)="changeActiveLocation($event.target)">
                                        <option *ngFor="let location of activeLocations" value="{{location.value}}">
                                            {{location.label}}
                                        </option>
                                    </select>
                                </div>
                            
                                <!-- Select Product -->
                                <div class="col-lg-2">
                                    <b>Select Product</b>
                                    <select class="form-control form-control-lg mt-2" (change)="changeActiveProduct($event.target)">
                                        <option selected disabled>Select Product</option>
                                        <option *ngFor="let item of activeProducts" value="{{item.id}}">
                                            {{item.productName}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-lg-4">
                                    <b>Delivery Message</b>
                                    <input class="form-control form-control-lg mt-2" type="text" #deliveryMsg/>
                                </div>
                            </div>
                            

                            <div class="row mt-4 pridproductdetails-controls" *ngIf="productDetailPage==true">
                                <h3>Product Details</h3>
                                
                                <!-- Product Image -->
                                <div class="col-lg-4">
                                    <img src="{{imageURL}}{{activeSelectedProduct.imageUrl}}" style="height: 300px; width: 250px;">
                                </div>
                                
                                <!-- Product Info -->
                                <div class="col-lg-5">
                                    <b>Product Name:</b> {{activeSelectedProduct.productName}}<br>
                                    <b>Quantity</b> &nbsp;<input type="number" #pridQuantity
                                        class="form-control-lg" style="width: 100px;" value="1">
                                    
                                    <button [disabled]="SubmitOrderButton==true" type="button" class="btn btn-lg btn-dark" 
                                        #btnAddToCartPridProduct
                                        (click)="AddToCartPridProduct(CustomerFirstName.value,CustomerLastName.value,
                                        CustomerEmail.value,CustomerPhone.value,
                                        recieverFirstName.value,recieverLastName.value,pridrecieverEmail.value,
                                        pridrecieverMobile.value, pridQuantity.value
                                        )">Add to Cart</button>
                                    
                                    <!-- Product Description -->
                                    Description: {{activeSelectedProduct.description}}<br>
                                    Product SKU: {{activeSelectedProduct.sku}}<br>
                                    <!-- Unit: {{activeSelectedProduct.unit}}<br> -->
                                    <!-- Category Name: {{activeSelectedProduct.categoryName}}<br> -->
                                      Retail Price: {{activeSelectedProduct.retailPrice}}<br>
                                    Stock Remaining: {{activeSelectedProduct.stockRemaining}}
                                </div>
                            
                                <!-- Empty Column (for layout spacing) -->
                                <div class="col-lg-3">
                                    <!-- <button type="button" class="btn btn-dark" (click)="AddToCartPridProduct(CustomerFirstName.value,CustomerLastName.value,CustomerEmail.value,CustomerPhone.value,
                                    recieverFirstName.value,recieverLastName.value,pridrecieverEmail.value,
                                    pridrecieverMobile.value, pridQuantity.value
                                    )">Add to Card</button> -->
                                    <input type="hidden" id="hdnPridProductDetails">
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="row">
                    <div class="col-lg-12" style="background-color: #343a40; height: 30px; color: white;">
                        <h5 style="padding: 8px;">Checkout</h5>
                    </div>
                </div>

                <div class="mt-3 border-bottom" *ngFor="let cart of OrderItem; let i=index">
                    <div class="row" [matTooltip]="cart.errorMsg">
                        <!-- <div class="row" *ngIf="cart.isProcessed==false"> -->
                        <div class="col-2">
                            <img src="{{cart.logoUrl}}" style="width: 100%;" class="rounded">
                        </div>
                        <div class="col-lg-5">
                            <b style="font-size: 15px;">{{cart.phoneNumber}}</b><br>

                            <label *ngIf="cart.productType==1">Domestic - </label>
                            <label *ngIf="cart.productType==2">International - </label>
                            <label *ngIf="cart.productType==3">Prid Product - </label>
                            {{cart.productDisplayText}}
                        </div>
                        <div class="col-lg-2" style="font-size: 15px;">
                            {{cart.quantity}} x ${{cart.retailPrice}}
                        </div>
                        <div class="col-lg-3">

                            <i class="fa fa-trash" *ngIf="cart.isProcessed==false" (click)="removeCartItem(i)"
                                style="background-color: red; padding: 5px; color: white;"></i> &nbsp;
                                <i *ngIf="cart.isProcessed==true" style="color: rgb(0, 109, 34); font-size: 20px;" class="fa-solid fa-check"></i>
                            <img *ngIf="cart.isProcessed==false && SubmitOrderButton==true"
                                src="https://png.pngtree.com/png-vector/20190223/ourmid/pngtree-reload-vector-icon-png-image_696434.jpg"
                                (click)="ReOrder(cart)" style="width: 30px; margin-left: 5px; cursor:pointer">
                        </div>
                    </div>
                    <!-- <span class="row" *ngIf="cart.isProcessed==true">
                        <div class="col-2">
                            <img [src]="cart.logoUrl" style="width: 100%;" class="rounded">
                        </div>
                        <div class="col-lg-6">
                            <b>{{cart.phoneNumber}}</b><br>
                            <label *ngIf="cart.productType==1">Domestic - </label>
                            <label *ngIf="cart.productType==2">International - </label>
                            <label *ngIf="cart.productType==3">Prid Product - </label>
                            {{cart.productDisplayText}}
                        </div>
                        <div class="col-lg-2">
                            {{cart.quantity}} x ${{cart.retailPrice}}
                        </div>
                        <div class="col-lg-2">

                            <i class="fa fa-trash" (click)="removeCartItem(i)"
                                style="background-color: red; padding: 5px; color: white;"></i> &nbsp;
                          <i class="fa-solid fa-check" style="color: green;"></i>

                        </div>
                    </span> -->
                </div>

                <div class="row mt-3" style="background-color: beige;">
                    <div class="col-lg-12">
                        <h2 *ngIf="SubmitOrderButton==true">Processed Amount: <span style="float: right;">
                                <h2>$ {{CartProcessedAmount}}</h2>
                            </span></h2>
                            <div *ngIf="CartFailedAmount>0">
                                <h2 *ngIf="SubmitOrderButton==true">Failed Amount: <span style="float: right;">
                                    <h2>$ {{CartFailedAmount}}</h2>
                                </span></h2>
                            </div>
                            <h2>Total Amount: <span style="float: right;">
                                <h2>$ {{CartTotalAmount}}</h2>
                            </span></h2>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-12">
                        <button *ngIf="SubmitOrderButton==false" (click)="PlaceOrder()" class="btn btn-danger w-100">Place
                            Order</button>

                        <button *ngIf="SubmitOrderButton==true && CartProcessedAmount>0" (click)="PrintRecipt()" class="btn btn-success w-100">
                            Print Recipt</button>
                        <button *ngIf="SubmitOrderButton==true" (click)="ResetAllCart(mob_number.value)"
                            class="btn btn-danger w-100">Clear Cart</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- </div> -->

    </div>


</div>
    <!-- Main Footer -->

<script>
    $(document).ready(function () {
        $('.collapse').on('show.bs.collapse', function () {
            $('.collapse.show').not(this).collapse('hide');
        });
    });
</script>